import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { PopupBaseComponent } from '../popup-base/popup-base.component';
import { ButtonComponent, ButtonType } from '../../button/button.component';
import { UserInputPopupModel } from './user-input-popup.model';
import { LayoutStore, LayoutStoreType } from '../../../../core/store/layout.store';

@Component({
    selector: 'juyo-user-input-popup',
    styleUrl: 'user-input-popup.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PopupBaseComponent, ButtonComponent, ReactiveFormsModule],
    template: `
        <juyo-popup-base [popupId]="model().id" [showHeader]="!!model().title">
            @if (model().title) {
                <span slot="header">{{ model().title }}</span>
            }

            <div slot="body" class="body">
                @if (model().content) {
                    <p class="content">{{ model().content }}</p>
                }
                <textarea
                    class="field"
                    rows="4"
                    [placeholder]="model().placeholder"
                    [formControl]="inputControl"
                ></textarea>
            </div>

            <ng-container slot="footer">
                <juyo-button [buttonType]="ButtonType.TRANSPARENT" (clicked)="onCancel()">
                    {{ model().cancelLabel }}
                </juyo-button>
                <juyo-button [buttonType]="ButtonType.PURPLE" (clicked)="onConfirm()">
                    {{ model().confirmLabel }}
                </juyo-button>
            </ng-container>
        </juyo-popup-base>
    `,
})
export class UserInputPopupComponent {
    public model = input.required<UserInputPopupModel>();

    protected readonly ButtonType = ButtonType;
    protected inputControl = new FormControl<string>('', { nonNullable: true });

    private layoutStore: LayoutStoreType = inject(LayoutStore);

    protected onConfirm(): void {
        const model = this.model();

        model.onConfirm(this.inputControl.value.trim());
        this.layoutStore.closePopup(model.id);
    }

    protected onCancel(): void {
        const model = this.model();

        model.onCancel();
        this.layoutStore.closePopup(model.id);
    }
}
